import React, { useState } from "react";
import styles from "./Register2.module.css";
import { registerUser } from "../../api/auth";
import { useNavigate } from "react-router-dom";
import arrow from "../../images/arrow.svg";
import Polygon from "../../images/Polygon.svg";
import Elipse1 from "../../images/Elipse1.svg";
import Elipse2 from "../../images/Elipse2.svg";

export default function Register() {
  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    password: "",
    checkpass: "",
  });

  const [errors, setErrors] = useState({
    name: null,
    email: null,
    checkpass: null,
    password: null,
  });


  const navigate = useNavigate();
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
   
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isErrors = false;

    if (formValues.name.trim().length === 0) {
      setErrors((prev) => ({ ...prev, name: "invalid name" }));
      isErrors = true;
    } else {
      setErrors((prev) => ({ ...prev, name: null }));
    }

    if (formValues.email.trim().length === 0) {
      setErrors((prev) => ({ ...prev, email: "invalid email" }));
      isErrors = true;
    } else {
      setErrors((prev) => ({ ...prev, email: null }));
    }

    if (formValues.password.trim().length === 0) {
      setErrors((prev) => ({ ...prev, password: "enter some value" }));
      isErrors = true;
    } else {
      setErrors((prev) => ({ ...prev, password: null }));
    }

    if (formValues.checkpass !== formValues.password) {
      setErrors((prev) => ({ ...prev, checkpass: "enter same password in both fields" }));
      isErrors = true;
    } else {
      setErrors((prev) => ({ ...prev, checkpass: null }));
    }

    if (!isErrors) {
      try {
        const result = await registerUser(formValues);
        if(result){
          navigate("/login");
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

 

  const gotoLogin = () => {
    navigate("/login");
  };

  const gotoLanding = () => {
    navigate("/");
  };

  return (
    <div className={styles.register2}>
      <img className={styles.arrow} src={arrow} onClick={gotoLanding} alt='arrow' />
      <img className={styles.Polygon} src={Polygon} alt='Polygon' />
      <img className={styles.Elipse1} src={Elipse1} alt='Elipse1' />
      <img className={styles.Elipse2} src={Elipse2} alt='Elipse2' />
      <form onSubmit={handleSubmit}>
        <div>
          <label className={`${styles.label1} ${errors.name ? styles.errorLabel : ''}`} htmlFor="name">Username</label><br />
          <input
            type="text"
            className={`${styles.input1} ${errors.name ? styles.errorInput : ''}`}
            placeholder="Name"
            value={formValues.name}
            onChange={handleChange}
            name="name"
          />
          {errors.name && <div className={styles.ename}>{errors.name}</div>}
        </div>
        <div>
          <label className={`${styles.label2} ${errors.email ? styles.errorLabel : ''}`} htmlFor="name">Email</label><br />
          <input
            type="email"
            className={`${styles.input2} ${errors.email ? styles.errorInput : ''}`}
            placeholder="Email"
            value={formValues.email}
            onChange={handleChange}
            name="email"
          />
          {errors.email && <div className={styles.eemail}>{errors.email}</div>}
        </div>
        <div>
          <label className={`${styles.label3} ${errors.password ? styles.errorLabel : ''}`} htmlFor="password">Password</label><br />
          <input
            type="text"
            className={`${styles.input3} ${errors.password ? styles.errorInput : ''}`}
            placeholder="Password"
            value={formValues.password}
            onChange={handleChange}
            name="password"
          />
          {errors.password && <div className={styles.epassword}>{errors.password}</div>}
        </div>
        <div>
          <label className={`${styles.label4} ${errors.checkpass ? styles.errorLabel : ''}`} htmlFor="checkpass">Confirm Password</label><br />
          <input
            type="text"
            className={`${styles.input4} ${errors.checkpass ? styles.errorInput : ''}`}
            placeholder="Confirm Password"
            value={formValues.checkpass}
            onChange={handleChange}
            name="checkpass"
          />
          {errors.checkpass && <div className={styles.echeckpass}>{errors.checkpass}</div>}
        </div>
        <button className={styles.register} type="submit">Sign Up</button>
      </form>
      <p className={styles.haveacc}>Already have an account ?<span className={styles.login} onClick={gotoLogin}> Login</span></p>
    </div>
  );
}
